// extracted by mini-css-extract-plugin
export default {"body":"RecalcProgressModal_body__aldxs","animation":"RecalcProgressModal_animation__o1lYL","message":"RecalcProgressModal_message__CLVda"};